import { combineReducers } from 'redux';
import menu from './menu';

const reducers = combineReducers({ menu });

export default reducers;
